import React from 'react';
import './styles.scss';
import SignIn from '../../components/SignIn';
import Footer from '../../components/Footer';

const Login = props => {
  return (
    <>
      <SignIn />
      <Footer/>
    </>
  );
}

export default Login;